// Import directly from the core implementation to avoid circular deps
import { defineStore } from 'pinia'
import { defaultParams } from '@/utils/constants'
import { getDeserializedCategoryProducts } from '@/utils/deserialization'

export const useBrandStore = defineStore('brand', {
  state: () => ({
    id: -1,
    breadcrumb: [],
    name: '',
    description: '',
    collapsedContent: '',
    products: [],
    meta: '',
  }),

  actions: {
    setBrand(brand) {
      this.breadcrumb = brand.breadcrumb
      this.id = brand.id
      this.meta = brand.meta
      this.name = brand.name
      this.description = brand.description
      this.collapsedContent = brand.collapsedContent
      this.products = [...brand.products]
    },

    async getBrand(brandId, options = {}) {
      const { rootStore = null, $axios = null, error = null } = options

      if (rootStore) {
        rootStore.removeError('brand')
        rootStore.addLoading('brand')
      }

      const couponCode = rootStore?.couponCode
      const params = { ...(couponCode && { couponCode }), ...defaultParams }

      // Get axios from nuxt context if not provided
      const axiosInstance = $axios || (process.client && window.$nuxt ? window.$nuxt.$axios : null)

      if (!axiosInstance) {
        console.error('❌ No axios instance available')
        if (rootStore) {
          rootStore.addError({ id: 'brand', error: new Error('No axios instance') })
          rootStore.removeLoading('brand')
        }
        return
      }

      try {
        const response = await axiosInstance.get(`brand/${brandId}`, { params })
        const { data: brand } = response.data
        const { products: brandProducts } = brand
        const deserializedProducts = getDeserializedCategoryProducts(brandProducts)
        const deserializedBrand = { ...brand, products: deserializedProducts }

        this.setBrand(deserializedBrand)
      } catch (err) {
        if (err.response?.status === 404 && error) {
          error({ statusCode: 404, message: 'Brand not found' })
        } else if (err.response?.status === 401 && rootStore) {
          await rootStore.silentLogOut({ source: 'brand/getBrand' })

          try {
            const response = await axiosInstance.get(`brand/${brandId}`, { params })
            const { data: brand } = response.data
            const { products: brandProducts } = brand
            const deserializedProducts = getDeserializedCategoryProducts(brandProducts)
            const deserializedBrand = { ...brand, products: deserializedProducts }

            this.setBrand(deserializedBrand)
          } catch (retryError) {
            if (rootStore) {
              rootStore.addError({ id: 'brand', error: retryError })
            }
          }
        }

        if (rootStore) {
          rootStore.addError({ id: 'brand', error: err })
        }
      } finally {
        if (rootStore) {
          rootStore.removeLoading('brand')
        }
      }
    },
  },
})
